import React from "react";
import {
  ActionsLayout,
  Dialog,
  DialogActionsBar,
} from "@progress/kendo-react-dialogs";
import { DialogProps } from "../interface/DialogProps";
import { Button } from "@progress/kendo-react-buttons";

export const DialogComponent = (dialogprops: DialogProps) => {
  const { title, content, showOk, showCancel, showError, onOk, onCancel } = dialogprops;
  const [layout, setLayout] = React.useState<ActionsLayout>("stretched");

  return (
    <div>
      <Dialog title={title} onClose={onCancel} width={350}>
        <div>
          <h6>{content}</h6>
        </div>
        <DialogActionsBar layout={layout}>
          {showCancel && (
            <button
              className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary"
              onClick={onCancel}
            >
              Cancel
            </button>
          )}
          {showOk && (
            <button
              className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary"
              onClick={onOk}
            >
              Ok
            </button>
          )}
          {showError && (<Button
            size={"medium"}
            themeColor={"error"}
            fillMode={"solid"}
            rounded={"medium"}
          >
            Ok
          </Button>)}
        </DialogActionsBar>
      </Dialog>
    </div>
  );
};
//export default dialogComponent;
